import { Component } from '@angular/core';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { RouterLink } from '@angular/router';
import { Chateau, CHATEAUX } from './chateau';

// Pour afficher les prix au format français (27 000).
registerLocaleData(localeFr);

@Component({
  selector: 'app-chateau-component',
  imports: [RouterLink, DecimalPipe],
  templateUrl: './chateau-component.html',
})
export class ChateauComponent {
  chateauList = CHATEAUX;
  selectedChateau: Chateau | null = null;

  openModal(chateau: Chateau) {
    this.selectedChateau = chateau;
    (document.getElementById('details_modal') as HTMLDialogElement).showModal();
  }
}
